//Models
PJQ.models.bidForms.Bidder = PJQ.models.BaseModel.extend({
    idAttribute: "contactCompanyId",
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'projects',
	            value: PJQ.app.session.project.id
            },
            {
                endpoint: 'contacts',
                value: !this.id && this.get('contactId') ? this.get('contactId') : this.id
            },
            {
                endpoint: 'proposals'
            }
        ])
    },
	parse: function (model) {
        if (model.proposals) {
            if (this.proposals)
                this.proposals.reset(model.proposals);
            else
                this.proposals = new PJQ.collections.bidForms.Proposals(model.proposals);

            _.each(this.proposals.models, function (proposal) {
                proposal.bidder = this;
            }, this);
        }
        else {
            this.proposals = new PJQ.collections.bidForms.Proposals();
        }

        if (model.contacts) {
            if (this.contacts)
                this.contacts.reset(model.contacts);
            else
                this.contacts = new PJQ.collections.bidForms.BidderContacts(model.contacts);
        }
        else {
            this.contacts = new PJQ.collections.bidForms.BidderContacts();
        }
        return model;
    },
    getProposal: function (bidFormId) {
        return this.proposals.findWhere({bidFormId: bidFormId})
    }
});

PJQ.models.bidForms.BidderContact = PJQ.models.projectParticipants.ProjectParticipant.extend({
    idAttribute: "contactId",
    getStatusColor: function () {
        switch (this.get('bidStatus').toLowerCase()) {
            case 'accept':
                return '#4CAF50';
            case 'decline':
                return '#dc3545';
            case 'bid received':
                return '#2196F3';
            case 'awarded':
                return '#4CAF50';
            case 'pending':
            default:
	            return '#9E9E9E';
        }
    },
    getProposal: function (bidFormId) {
        return this.proposals.findWhere({bidFormId: bidFormId})
    }
});


//Collections
PJQ.collections.bidForms.Bidders = PJQ.collections.BaseCollection.extend({
    model: PJQ.models.bidForms.Bidder,
    getProposals: function (bidFormId) {
	    let proposals = new PJQ.collections.bidForms.Proposals([], {bidFormId: bidFormId});
        _.each(this.models, function (model) {
            _.each(model.proposals.models, function (proposal) {
                if (bidFormId == null || proposal.get('bidFormId') === bidFormId)
                    proposals.add(proposal);
            });
        });
        return proposals;
    },
    getProposalCount: function (bidFormId) {
        let proposalCount = 0;
        _.each(this.models, function (model) {
            proposalCount += model.get('proposalCount');
        });
        return proposalCount;
    },
	removeProposal: function (proposal) {
		_.each(this.models, function (model) {
			let matchProposal = model.proposals.get(proposal.id);
			if(matchProposal != null){
				model.proposals.remove(proposal);
			}
		});
	},
    getLowestProposal: function (bidFormId, isIncludeAlternates) {
        return this.getProposals(bidFormId).getLowestProposal(isIncludeAlternates);
    }
});

PJQ.collections.bidForms.BidderContacts = PJQ.collections.contacts.Contacts.extend({
    model: PJQ.models.bidForms.BidderContact
});